<template>
    <div class="d-flex flex-row mt-1 py-1" 
        style="border-bottom: 1px dashed lightgray;"
    >
        <div class="flex-grow-0 flex-shrink-0">
            <div class="form-item form-item-width-2 mb-1">
				<label class="form-item-label mt-1 mr-1">选择门店:</label>				
                <v-select
                    class="form-item-value"
                    v-model="selectedOrgId"
                    :items="orgs"						
                    label=""
                    hide-details											
                    flat
                    item-text="shopName"
                    item-value='shopId'
                    outlined
                    dense		
                    clearable									
                >
                </v-select>
				
			</div>

            
        </div>
        <div class="form-item form-item-width-1 py-0 ma-0">
				<label class="form-item-label py-0 mt-0 mr-1">手机号:</label>
				<v-text-field 
					class="form-item-value py-0" 								
					outlined
					dense
					placeholder=""
					v-model="mobile"
				>
				</v-text-field>						
			</div>

        <div class="flex-grow-0 flex-shrink-0">
            <v-btn ref="queryButton" v-if="getQueryButtonExists()" :dark="queryButtonDark" :color="queryButtonColor"
            :class="queryButtonCssClass" class="white--text"
            @click="queryClicked"
        >
            <v-icon>{{queryButtonIcon}}</v-icon>
            <span>{{queryButtonText}}</span>
        </v-btn>
        </div>
        
    </div>
</template>

<script>
    import OrgApi from "../../../../api/smp/org/DepartmentApi.js";
    import Permission from "../../../../api/smp/auth/Permission.js";

    export default {
        name:'PersonManageQueryConditionPane',
        props:['context'],
        data () {
            return {
                name:'PersonManageQueryConditionPane',
                //查询条件
                selectedOrgId:null,
                mobile:"",

                orgs:[],
            }
        },
        methods:{
            initComponent(){

            },
            initSignals(){

            },
            getModeHelper(){
                return this.context.modeHelper;
            },
            getSignals(){
                return this.context.signals;
            },
            getMessageDialogHelper(){
                return this.context.messageDialogHelper;
            },
            getQueryButtonExists(){
                return this.getModeHelper().getQueryButtonExists();
            },

            getQueryButtonPermited(){
                return this.getModeHelper().getQueryButtonPermited();
            },

            async loadOrgs(){
                let me = this;
                let queryShopPriviledgeResp = await Permission.queryShopPriviledge();
                console.log("load shop previledge returned;");

                console.log(queryShopPriviledgeResp);
                
                let data = queryShopPriviledgeResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'获取门店权限情况失败':msg;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.shopPriviledges)){
                    throw new Error('获取门店权限情况失败(无会话数据)');
                    return;
                }
                
                this.orgs = data.data.shopPriviledges;
            },
            queryClicked(){
                if((!this.selectedOrgId)&&((this.mobile=='')||(!this.mobile))){
                    this.getMessageDialogHelper().errMsg("错误","还没有选择条件");
                    return;   
                }
                let params = {};
                if(this.selectedOrgId)
                    params.selectedOrgId=this.selectedOrgId;
                if((this.mobile)&&(this.mobile!=''))
                    params.mobile = this.mobile;
                let me = this;
                this.getSignals().loadQueryResultAsked.dispatch(params);
            }
        },
        computed:{
            
            queryButtonIcon(){
                return "mdi-file-search-outline";
            },
            queryButtonText(){
                return "查询";
            },
            queryButtonCssClass(){
                return "ml-1 round";
            },
            queryButtonColor(){
                return "purple";
            },
            queryButtonDark(){
                return false;
            },

            
        },
        created(){
            this.bill = this.context.bill;
            this.signals = this.context.signals;
            this.initComponent();
            this.initSignals();
        },
        mounted(){
            console.log("person.queryConditionPane loaded");
            this.loadOrgs();
        }
    }
</script>

<style scoped>
</style>
